<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="608px"
    title="修改备注"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <el-form ref="form" class="form" :model="form" :rules="rules" label-position="top">
      <el-form-item label="填写备注内容" prop="remarks">
        <el-input
          v-model="form.remarks"
          type="textarea"
          :rows="6"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok('form')">确定</div>
    </span>
  </el-dialog>
</template>
  <script>
  import { updateMBLSendWayRemarks } from '@/api/bill'
  export default {
      props: {
          dialogVisible: {
            type: Boolean,
            default: false
          },
          editData: {
            type: Object,
            default: function() {
                return {}
            }
          }
      },
    data() {
      return {
        form: {
            remarks: ''
        },
        rules: {
            remarks: [{ required: true, message: '填写备注内容', trigger: 'blur' }]
        }
      }
    },
    watch: {
        dialogVisible(value) {
            if (value) {
                this.form.remarks = this.editData.remarks
            }
        }
    },
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      ok(formName) {
        this.$refs[formName].validate(async(valid) => {
            if (valid) {
            const params = {
                ...this.form,
                mblSenbWayId: this.editData.id
            }
            try {
                const res = await updateMBLSendWayRemarks(params)
                if (res.success) {
                    this.$message.success('操作成功')
                    this.$emit('ok')
                } else {
                    this.$message.error(res.errorMessage)
                }
            } catch (error) {
                console.log(error)
            }
            }
        })
     }
    }
  }
  </script>
  <style lang="less" scoped>
  :deep(.el-dialog__body) {
    padding: 30px 60px;
  }
  .footers {
    width: 100%;
    display: flex;
    justify-content: center;
    & div {
      width: 160px;
      height: 40px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
    }
    .cancel {
      background: #f2f7ff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dbe4f2;
      color: #7c8db5;
      margin-right: 16px;
      box-sizing: border-box;
    }
    .ok {
      background:  rgb(18,88,188);
      border-radius: 4px 4px 4px 4px;
      color: #ffffff;
    }
  }
  /deep/ .el-form-item__label {
    line-height: 20px;
  }
  </style>

